import { HTMLReactParserOptions } from 'html-react-parser';
import fonts from 'Theme/lightTheme/fonts';

import { H4 } from 'Elements/Typography';

export const h4AsBilo: HTMLReactParserOptions = {
    replace: domNode => {
        if (domNode.children) {
            switch (domNode.name) {
                case 'h4':
                    return (
                        <H4 fontFamily={fonts.secondary} weight="300">
                            {domNode.children[0].data}
                        </H4>
                    );
                default:
                    return domNode;
            }
        } else {
            return domNode;
        }
    }
};
